<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
    class="vb-dialog vb-dialog-danger"
  >

    <template v-slot:activator="{ props }">
      <div v-bind="props" >
        <slot></slot>
      </div>
    </template>

    <v-card class="">
      <v-card-title class="d-flex justify-space-between dialog-title">
        {{$t('menus.configuration.deleteAccount')}}

        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="scrollable pt-4">
        <v-row>
          <v-col>
            {{ $t('menus.deleteAccount.weSadToSeeYou') }}
          </v-col>
        </v-row>

        <v-row>
          <v-col class="font-weight-bold">
            {{ $t('menus.deleteAccount.warningMessage1') }}
          </v-col>
        </v-row>

        <v-row v-if="hasTenantForDeletion" class="">
          <v-col>
            {{ $t('menus.deleteAccount.youAreTheOwner') }}:

            <ul class="my-2 ml-4">
              <li v-for="tenant in tenantsOwned" :key="tenant">
                {{ tenant }}
              </li>
            </ul>

            <strong>{{ $t('menus.deleteAccount.importantNote') }}:</strong>
            <p>
              {{ $t('menus.deleteAccount.deletingAccountDeletesTheTenants') }}
            </p>
            <br/>

            <strong> {{ $t('menus.deleteAccount.toAvaidLosingTenants') }}:</strong>
            <p>
              {{ $t('menus.deleteAccount.toTransferOwnership') }}
            </p>

          </v-col>
        </v-row>

        <v-row>
          <v-col class="font-weight-bold">
            {{ $t('menus.deleteAccount.warningMessage2') }}
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              v-model="deleteAccountText"
              variant="solo-filled" flat
              class="mt-4"
              :disabled="accountCannotBeDeleted"
              hide-details="auto"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <div v-if="errorMessage" class="bg-error mb-4" style="width: 100%;">
              {{ errorMessage }}
            </div>
            <div v-if="isSuccess" class="bg-success mb-4" style="width: 100%;">
              {{ $t('menus.deleteAccount.deletionProcessInfo') }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="bg-red-darken-3 text-white" elevation=0 @click="deleteAccount()" :disabled="isDisabled">{{ $t('common.delete') }}</v-btn>
        <v-btn variant="text" @click="dialog = false">{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore'
import { useAccountStore } from '@/stores/AccountStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  mixins: [DialogActionKeys],
  name: "DeleteAccountDialog",
  props: {
    openOnMount: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      dialog: false,
      deleteAccountText: "",
      isSuccess: false,
      errorMessage: "",
      userInfo: null,
      deletionInProgress: false,
    }
  },
  mounted: function() {
    if (this.openOnMount) {
      this.dialog = true;
    }
  },
  watch: {
    dialog(newValue) {
      if(newValue) {
        this.resetForm();

        const self = this;

        const accountStore = useAccountStore();
        accountStore.getAccountDeletionInfo()
          .then(function(result) {
            self.userInfo = result;

            if (result && !result.canBeDeleted) {
              self.errorMessage = self.$t('menus.deleteAccount.accountCannotBeDeleted');
            }
          })
          .catch(function(error) {
            console.error(error);
          });
      }
    }
  },
  methods: {
    resetForm() {
      this.deleteAccountText = "";
      this.deletionInProgress = false;
      this.isSuccess = false;
      this.errorMessage = "";
    },
    deleteAccount: function() {
      this.deletionInProgress = true;
      this.errorMessage = "";

      if (this.isSuccess) {
        this.dialog = false;
        this.deleteAccountText = "";
        return;
      }

      let self = this;

      const accountStore = useAccountStore();
      accountStore.deleteAccount()
      .then(function(result) {
        if (result.success) {
          self.isSuccess = true;

          setTimeout(() => {
            self.$router.push('/account/logout');
          }, 2000);
        }
      })
      .catch(function(error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          self.errorMessage = error.response.data.error.message;
        } else {
          self.errorMessage = "Error!";
        }
      });
    },
  },
  computed: {
    isDisabled() {
      return this.deletionInProgress
          || this.accountCannotBeDeleted
          || (this.deleteAccountText.toLowerCase() !== "delete account");
    },
    user: function() {
      const authStore = useAuthStore();
      return authStore.dbUser;
    },
    hasTenantForDeletion: function() {
      if (this.userInfo && this.userInfo.hasTenants) {
        return true;
      }

      return false;
    },
    tenantsOwned: function() {
      return this.userInfo?.tenantsOwned || [];
    },
    accountCannotBeDeleted: function() {
      if (this.userInfo && !this.userInfo.canBeDeleted) {
        return true;
      }

      return false;
    }
  }
}
</script>

<style>
.vb-delete-account-dialog .v-card__text {
  font-size: 1.1rem;
}
</style>
